export const admessageConstants = {

    FETCH_ADMESSAGES_REQUEST: 'FETCH_ADMESSAGES_REQUEST',
    FETCH_ADMESSAGES_SUCCESS: 'FETCH_ADMESSAGES_SUCCESS',
    FETCH_ADMESSAGES_FAILURE: 'FETCH_ADMESSAGES_FAILURE',

    CREATE_ADMESSAGE_REQUEST: 'CREATE_ADMESSAGE_REQUEST',
    CREATE_ADMESSAGE_SUCCESS: 'CREATE_ADMESSAGE_SUCCESS',
    CREATE_ADMESSAGE_FAILURE: 'CREATE_ADMESSAGE_FAILURE',

    UPDATE_ADMESSAGE_REQUEST: 'UPDATE_ADMESSAGE_REQUEST',
    UPDATE_ADMESSAGE_SUCCESS: 'UPDATE_ADMESSAGE_SUCCESS',
    UPDATE_ADMESSAGE_FAILURE: 'UPDATE_ADMESSAGE_FAILURE',

    DELETE_ADMESSAGE_REQUEST: 'DELETE_ADMESSAGE_REQUEST',
    DELETE_ADMESSAGE_SUCCESS: 'DELETE_ADMESSAGE_SUCCESS',
    DELETE_ADMESSAGE_FAILURE: 'DELETE_ADMESSAGE_FAILURE',

}